import styled from "styled-components";
import { FileInputProps } from "./FileInput.types";
import COLORS from "../../constants/colors";

export const FileInputWrapper = styled.div<Partial<FileInputProps>>`
    border: 2px dashed ${COLORS.GREY_400};
    border-radius: 4px;

    label {
        cursor: pointer;
        margin: 0;
        display: block;
        &:focus-within {
            outline: none;
        }
    }
`;

export const FileInputPreviewer = styled.img<Partial<FileInputProps>>`
    max-width: 100%;
    max-height: 240px;
`;
